import PubSub from "underpub-js";

var VideoSpotlight = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-VideoSpotlight',
	};

	$.extend(true, this.options, options);

};

VideoSpotlight.prototype.init = function() {

	var self = this;

};

export default VideoSpotlight;
